import { Box, Container, forwardRef, Heading, Link, Text } from "@chakra-ui/react";
import analyticsInstance from "../../config/analytics";

const GM = forwardRef((props, ref) => {
  return (
    <Box bg="#F3DAFF" py="8em">
      <Container
        ref={ref}
        {...props}
        bg="linear-gradient(180deg, rgba(172,172,172,1) 0%, rgba(145,255,139,1) 50%, rgba(255,251,0,1) 100%)"
        py="1em"
        borderRadius="0.25em"
        maxW={{ base: "75%", md: "fit-content" }}
      >
        <Heading size="lg">What's BTFDCA?</Heading>
        <Text pt="0.5em">
          <u>Tired</u> of trying and <u>failing</u> to time the market? 😫
        </Text>
        <Text>
          Keeping up with crypto-twitter makes you <u>FOMO</u> or <u>Weak Hands</u>? 😱
        </Text>
        <Text>
          Do you feel like you have <u>better things to do</u> with your time than trade? 💭
        </Text>

        <Text pt="2em">
          Use BTFDCA to buy crypto-assets through <u>dollar-cost average</u> (DCA). 📈
        </Text>
        <Text>
          With DCA, you <u>buy assets over time</u>, instead of YOLO lump-sums. 🐢
        </Text>
        <Text>
          BTFDCA has the <u>assets you want to buy</u>, and <u>automates</u> the whole DCA process. 🦾
        </Text>
        <Text pt="1em" pb="2em">
          <u>Easily</u> set your orders, and <u>relax</u>. 🏖️
        </Text>

        <Text>
          🆕 New to BTFDCA?&nbsp;
          <Link
            color="teal.500"
            _hover={{ textDecoration: "none" }}
            href="/faq"
            onClick={() => analyticsInstance.track("FAQClicked")}
            isExternal
          >
            Check the FAQ.
          </Link>
        </Text>
        <Text>
          📞 Need to get in touch?&nbsp;
          <Link
            color="teal.500"
            _hover={{ textDecoration: "none" }}
            href="mailto:contact@btfdca.com?subject=yo BTFDCA&body=<replace this with your message>"
            onClick={() => analyticsInstance.track("EmailClicked")}
            isExternal
          >
            Email
          </Link>
          &nbsp;or&nbsp;
          <Link
            color="teal.500"
            _hover={{ textDecoration: "none" }}
            href="https://twitter.com/btfdca_finance"
            onClick={() => analyticsInstance.track("TwitterClicked")}
            isExternal
          >
            Twitter
          </Link>
          &nbsp;or&nbsp;
          <Link
            color="teal.500"
            _hover={{ textDecoration: "none" }}
            href="https://discord.gg/AcgfRqukQt"
            onClick={() => analyticsInstance.track("DiscordClicked")}
            isExternal
          >
            Discord
          </Link>
          .
        </Text>
        <Text pt="1em">🎆 LFG! 🎆</Text>
      </Container>
    </Box>
  );
});

export default GM;
